import _ from "underscore.string";
import Typograf from "typograf";
import {autotypograf} from "../plugins/helperPlugin/functions/autotypograf";

export const Beautify = {
    twoWay:          true,
    isLiteral:       true,
    acceptStatement: false,

    bind: (el, binding, vnode) => {
        var rules = binding.value.split(" ");

        if (rules.indexOf('typograf') >= 0 && rules.indexOf('onlyonblur') === -1) {
            let disableRules = [
                'ru/money/ruble',
                'common/html/nbr',
                'common/nbsp/afterNumber',
                'ru/nbsp/afterNumberSign',
                'common/nbsp/afterParagraph',
                'common/nbsp/afterShortWord',
                'common/nbsp/beforeShortLastWord',
                'common/space/delTrailingBlanks',
                'common/space/delRepeatSpace',
                'common/space/trimRight',
                // 'common/space/delRepeatN',
            ];
            let enableRules = [
                'common/space/delLeadingBlanks',
                'common/nbsp/replaceNbsp',
                'common/space/afterPunctuation'
            ];
            if (rules.indexOf('withoutinitialspaces') >= 0) {
                disableRules.push('ru/nbsp/initials')
                disableRules.push('ru/nbsp/abbr')
                disableRules.push('ru/nbsp/see')
            }

            autotypograf(el, {locale: 'ru'}, disableRules, enableRules);
        }

        const handlerRealtime = () => {
            let value = el.value;

            if (rules.indexOf('unquote') >= 0) {
                value = _.unquote(value, '"');
            }
            if (rules.indexOf('striptags') >= 0) {
                value = _.stripTags(value);
            }

            if (rules.indexOf('escape') >= 0) {
                value = _.escape(value);
            }
            if (rules.indexOf('clean') >= 0) {
                value = _.clean(value);
            }
            if (rules.indexOf('nohttp') >= 0) {
                value = _.replaceAll(value, 'http://www.', '');
                value = _.replaceAll(value, 'https://www.', '');
                value = _.replaceAll(value, 'http://', '');
                value = _.replaceAll(value, 'https://', '');

                if (_(value).startsWith('www.')) {
                    value = value.slice(4);
                }
            }

            if (rules.indexOf('vk') >= 0) {
                value = _.replaceAll(value, 'vkontakte.ru', 'vk.com');
                value = _.replaceAll(value, 'm.vk.com', 'vk.com');
                value = _.replaceAll(value, 'm.vk.com', 'vk.com');
                value = _.replaceAll(value, 'vk.me', 'vk.com');
                value = _.replaceAll(value, 'new.vk.com', 'vk.com');
            }
            if (rules.indexOf('youtube') >= 0) {
                value = _.replaceAll(value, 'youtu.be', 'youtube.com');
            }
            if (rules.indexOf('facebook') >= 0) {
                value = _.replaceAll(value, 'prod.facebook.com', 'facebook.com');
                value = _.replaceAll(value, 'ru-ru.facebook.com', 'facebook.com');
                value = _.replaceAll(value, 'web.facebook.com', 'facebook.com');
                value = _.replaceAll(value, 'hfacebook.com', 'facebook.com');
                value = _.replaceAll(value, 'fb.me', 'facebook.com');
                value = _.replaceAll(value, 'fb.com', 'facebook.com');
                value = _.replaceAll(value, 'm.facebook.com', 'facebook.com');
                value = _.replaceAll(value, 'business.facebook.com', 'facebook.com');
            }
            if (rules.indexOf('ok') >= 0) {
                value = _.replaceAll(value, 'm.ok.ru', 'ok.ru');
                value = _.replaceAll(value, 'odnoklassniki.ru', 'ok.ru');
            }

            if (rules.indexOf('itemclean') >= 0) {
                var countQuotes = _.count(value, "'") + _.count(value, '"') + _.count(value, "«") + _.count(value, "»") + _.count(value, "„") + _.count(value, "“");
                var startsWithQuote = _.startsWith(value, "'") || _.startsWith(value, '"') || _.startsWith(value, "«") || _.startsWith(value, "„");
                var endsWithQuote = _.endsWith(value, "'") || _.endsWith(value, '"') || _.endsWith(value, "»") || _.endsWith(value, "“");

                if ((countQuotes === 2) && startsWithQuote && endsWithQuote) {
                    value = _.trim(value, '"\'«»„“');
                }
            }

            if (rules.indexOf('capitalize') >= 0) {
                value = _.capitalize(value);

                if (rules.indexOf('rusAB') >= 0) {
                    if (value[0] === 'A'){
                        value = value.replace('A', 'А');
                    }
                    if (value[0] === 'B'){
                        value = value.replace('B', 'В');
                    }
                }
            }

            if(el.value !== value) {
                el.value = value;
                el.dispatchEvent(new Event("input", { bubbles: true }));
                //el.setSelectionRange(value.length, value.length)
            }

        };

        const handlerOnLeave = () => {
            let value = el.value;

            if (rules.indexOf('nohttp') >= 0) {
                value = _.rtrim(value, '/');
            }
            if (rules.indexOf('ltrim') >= 0) {
                value = _.ltrim(value);
            }
            if (rules.indexOf('trim') >= 0) {
                value = _.trim(value);
            }
            if (rules.indexOf('rtrim') >= 0) {
                value = _.rtrim(value, ' ');
            }
            if (rules.indexOf('rtrimpunctuation') >= 0) {
                value = _.rtrim(value, ' .,;!?');
            }
            if (rules.indexOf('itemclean') >= 0) {
                var countQuotes = _.count(value, "'") + _.count(value, '"') + _.count(value, "«") + _.count(value, "»") + _.count(value, "„") + _.count(value, "“");
                var startsWithQuote = _.startsWith(value, "'") || _.startsWith(value, '"') || _.startsWith(value, "«") || _.startsWith(value, "„");
                var endsWithQuote = _.endsWith(value, "'") || _.endsWith(value, '"') || _.endsWith(value, "»") || _.endsWith(value, "“");

                if ((countQuotes === 2) && startsWithQuote && endsWithQuote) {
                    value = _.trim(value, '"\'«»„“');
                }
            }
            if (rules.indexOf('capitalize') >= 0) {
                value = _.capitalize(value);
            }

            if (rules.indexOf('typograf') >= 0) {
                var tp = new Typograf({locale: 'ru'});
                tp.disableRule('ru/money/ruble');
                // tp.disableRule('common/space/delRepeatN');
                tp.disableRule('common/html/nbr');
                tp.disableRule('common/nbsp/afterNumber');
                tp.disableRule('common/nbsp/afterParagraph');
                tp.disableRule('common/nbsp/afterShortWord');
                tp.disableRule('common/nbsp/beforeShortLastWord');

//                tp.disableRule('common/space/delTrailingBlanks');
                tp.enableRule('common/space/afterPunctuation');
                tp.enableRule('common/space/delLeadingBlanks');
                tp.enableRule('common/nbsp/replaceNbsp');

                if (rules.indexOf('withoutinitialspaces') >= 0) {
                    tp.disableRule('ru/nbsp/initials')
                    tp.disableRule('ru/nbsp/abbr');
                    tp.disableRule('ru/nbsp/see');
                }

                value = tp.execute(value);
            }

            el.value = value;
            if (rules.indexOf('noblurinput') === -1) {
                el.dispatchEvent(new Event("input", { bubbles: true }));
            }
        };

        if (rules.indexOf('onlyonblur') === -1) {
            el.addEventListener('focus', handlerRealtime);
            el.addEventListener('paste', handlerRealtime);
            el.addEventListener('input', handlerRealtime);
            el.addEventListener('change', handlerRealtime);
            el.addEventListener('text:beautify', handlerRealtime);
        }

        el.addEventListener('blur', handlerOnLeave);

        setTimeout(() => {
            let event = new Event("text:beautify");
            el.dispatchEvent(event);
        }, 1);
    }
};
